const SET_LAST_KEYBOARD_CONTEXT = 'SET_LAST_KEYBOARD_CONTEXT';
const SET_IS_COLLAPSING_MENU_FROM_KEYBOARD = `SET_IS_COLLAPSING_MENU_FROM_KEYBOARD`;
export { SET_LAST_KEYBOARD_CONTEXT, SET_IS_COLLAPSING_MENU_FROM_KEYBOARD };
